import React, {Component} from 'react'


class OrSeparator extends Component {
    render() {
        return (
            <div style={{width: '400px', textAlign: 'center'}}>
                <hr style={{width: '400px', position: 'absolute', marginTop: '10px'}}/>
                <span style={{background: 'white', padding: '10px', position: 'relative'}}> or </span>
            </div>
        )
    }
}

export default OrSeparator



// WEBPACK FOOTER //
// ./src/components/search/FormElements/OrSeparator/OrSeparator.js